// extracted by mini-css-extract-plugin
export default {"background":"background_background__1O4zY","backgroundImg":"background_backgroundImg__q9JAp"};